var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"图片"}},[_c('b-form-file',{ref:"img-input",attrs:{"browse-text":"上传","placeholder":"请选择图片","accept":"image/*"},on:{"input":_vm.uploadFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }